import { format, parseISO } from 'date-fns'

const formatDateToView = (dateString: string): string => {
  if (!dateString) return ''

  const date = parseISO(dateString)
  return format(date, 'dd/MM/yyyy')
}

export {
  formatDateToView
}
